module.exports = {

    data(){
        return {
            form: new Form({
                name: '',
                email: '',
                project_number: '',
                permit_number: '',
                employer_number: '',
                technician_number: '',
                communication: 'Normal',
                forms_submited_on_time: 'No',
                answered_questions: 'No',
            })
        }
    },

    methods:{
        onSubmit(){
            this.form.post(event.target.action).then(response => {
                Alert.success(response.message)
            }).catch(errors => {
                Alert.error(errors.first())
            })
        }
    }
}
